import React from "react";
import { Header, SlideLayout, Text } from "../../shared-components";
import { IconVariant } from "../../shared-components/Header";
import Slack from "./assets/slack.svg";
export const SlackSlide = () => {
  return (
    <SlideLayout>
      <Header iconVariant={IconVariant.Slack}> Download Clockwise for Slack </Header>
      <Text>
        Our Chrome extension allows you to access Clockwise in your daily workflows, without ever
        having to leave your calendar.
      </Text>
      <div className="cw-my-6 cw-w-full cw-flex cw-items-center cw-justify-center">
        <img src={Slack} className="cw-w-full md:cw-w-[600px]" />
      </div>
    </SlideLayout>
  );
};
